import { EqlField } from 'generated/graphql';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface getCompareLabelPrefixParams {
  formulaID: EQLFunctionName;
  measuredAsCriteria: EqlField | null;
}

export function getCompareLabelPrefix({
  formulaID,
  measuredAsCriteria,
}: getCompareLabelPrefixParams) {
  if (formulaID === EQLFunctionName.NPS) {
    return 'NPS in';
  }

  if (formulaID === EQLFunctionName.CSAT) {
    return 'CSAT in';
  }

  if (formulaID === EQLFunctionName.Mean) {
    return 'Mean in';
  }

  const formulaUnit =
    formulaID === EQLFunctionName.NormaliseByPercent ? '%' : '';

  if (measuredAsCriteria) {
    return `${formulaUnit} ${measuredAsCriteria.displayName} in`;
  }

  if (formulaID === EQLFunctionName.Count) {
    return 'Records in';
  }

  if (formulaID === EQLFunctionName.NormaliseByPercent) {
    return `${formulaUnit} Records in`;
  }

  return '';
}
